// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"project-module--cards-container--3R8ha","largeTitle":"project-module--large-title--1Ngkg"};